<script>
    import FacebookIcon from "@propublica/pp-v5-shared/src/icons/facebook.svg";
    import TwitterIcon from "@propublica/pp-v5-shared/src/icons/twitter.svg";
    import Button from "../Button";
    import CopyButton from "../CopyButton";

    // Prop fallbacks are for SSR, when window and document aren't available

    /** The URL to be shared. If you are instantiating ShareTools in SSR, then
     * you must specify this URL; otherwise, the ShareTools will not show up. If
     * you are only instantiating ShareTools in client JS, then it defaults to
     * the current page's URL, detected by JS (no need to specify this prop).
     * @type {string}
     */
    export let pageUrl =
        typeof window !== "undefined" ? window.location.href : null;

    /** The page title that will get autopopulated in the tweet dialog. If
     * you are instantiating ShareTools in SSR, we recommend that you fill
     * this; otherwise it defaults to an empty string. If you are only
     * instantiating ShareTools in client JS, then it defaults to the page's
     * `<title>` (no need to specify this prop).
     * @type {string}
     */
    export let pageTitle =
        typeof document !== "undefined" ? document.title : "";

    /** @type {object} */
    export let buttonProps = {
        bgColor: "var(--color-accent-50)",
        textColor: "var(--color-bg)",
        iconOnly: true,
        shape: "circle",
    };
</script>

{#if pageUrl !== null}
    <div class="share-tools" data-pp-location="share tools">
        <ul class="share-tools__btn-list">
            <li>
                <Button
                    elementType="a"
                    href="https://twitter.com/intent/tweet?url={encodeURI(
                        pageUrl
                    )}&text={encodeURI(pageTitle)}"
                    {...buttonProps}
                >
                    <TwitterIcon slot="iconBefore" />
                    Twitter
                </Button>
            </li>
            <li>
                <Button
                    elementType="a"
                    href="https://www.facebook.com/sharer/sharer.php?u={encodeURI(
                        pageUrl
                    )}"
                    {...buttonProps}
                >
                    <FacebookIcon slot="iconBefore" />
                    Facebook
                </Button>
            </li>
            <li>
                <CopyButton textToCopy={pageUrl} {buttonProps} />
            </li>
        </ul>
    </div>
{/if}

<style lang="scss">
    @import "@propublica/pp-v5-shared/src/css/utils/dark-mode.mixins";

    .share-tools__btn-list {
        display: flex;
        flex-direction: row;
        gap: var(--spacing-1);
    }
</style>
